export default "__VITE_ASSET__BNV$9aer__"